import { fg } from '@atlassian/jira-feature-gating';

const IsDFOCreateBranchTargetsEnabledRelayProvider = {
	get(): boolean {
		return fg('jpx-818-dfo-create-branch-targets');
	},
};

export default IsDFOCreateBranchTargetsEnabledRelayProvider;
